import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Box } from '@gemini/core';
import { ButtonGroup } from '@gemini/ui';
import { useEffect } from 'react';
import { useTransactionType } from '@/hooks/useTransactionType';
import { useTranslation } from '@/hooks/useTranslations';
export function TransactionTypeButtonGroup({ offers }) {
    var _a, _b, _c;
    const { setTransactionType } = useTransactionType();
    const { t } = useTranslation();
    const handleButtonChange = (value) => {
        const matchedOffer = offers.find((offer) => offer.name === value);
        setTransactionType(matchedOffer.transactionType);
    };
    const defaultTransactionTypeValue = (_b = (_a = offers.find((offer) => offer.default)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = offers[0]) === null || _c === void 0 ? void 0 : _c.name;
    const buttonOptions = {
        items: offers === null || offers === void 0 ? void 0 : offers.map(({ name, label }) => ({
            label: t(label),
            value: name,
        })),
        defaultButtonValue: defaultTransactionTypeValue,
    };
    useEffect(() => {
        var _a, _b, _c;
        const defaultValue = (_b = (_a = offers.find((offer) => offer.default)) === null || _a === void 0 ? void 0 : _a.transactionType) !== null && _b !== void 0 ? _b : (_c = offers[0]) === null || _c === void 0 ? void 0 : _c.transactionType;
        setTransactionType(defaultValue);
    }, []);
    return (_jsx(Box, { testId: "transactionType-button-group-container", display: "flex", justifyContent: "center", children: _jsx(ButtonGroup, { testId: "transactionType-button-group", name: "transactionType", label: "Button Group", items: buttonOptions.items, defaultValue: buttonOptions.defaultButtonValue, onChange: (value) => handleButtonChange(value) }) }));
}
